module.exports = __webpack_public_path__ + "static/media/background2.ef71b378.png";